<template>
  <div
    class="
      h-full
      min-h-screen
      md:min-h-0
      flex flex-col
      bg-black
      playlist-favorite
    "
    v-if="dataObj"
  >
    <header class="relative px-5 py-10 flex items-start">
      <NavMenu :isDark="true" />
      <router-link
        class="w-15 h-15 cursor-pointer flex justify-center items-center"
        to="/search-tracks"
      >
        <Icon id="arrowLeft" />
      </router-link>
      <h1 class="text-base text-white text-center w-full mr-4">
        {{ dataObj.text }}
      </h1>
    </header>
    <div class="flex-1 px-4 pb-56 md:overflow-y-scroll music-list">
      <MusicCard
        v-for="(track, index) in tracks"
        :key="index"
        :title="track.name"
        :subtitle="track.artist_name"
        :images="track.images"
        :isFavorite="selectedId === track.id"
        @click.native="selectedId = track.id"
      />
    </div>
    <div
      v-if="selectedId > 0"
      class="px-10 py-12 fixed bg-black left-0 md:absolute bottom-0 w-full"
    >
      <router-link :to="dataObj.linkUrl" @click.native="onNext">
        <Button :title="dataObj.button" />
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import { RouteGuardHandler } from '@/mixins/route-guard-handler'
import { TranslationHandler } from '@/mixins/translation-handler'
import { RestTrack } from '@/types'
import { move } from '@/utils/array'
import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

enum FavoriteId {
  OPENING = 'opening',
  CLOSING = 'closing',
  ENCORE = 'encore',
}

@Component({
  components: {
  },
})
export default class SearchTracks extends Mixins(TranslationHandler, RouteGuardHandler) {
  @Getter campaignTracks!: RestTrack[]

  favoriteId: FavoriteId | null = null

  selectedId = -1

  created () {
    this.$routeGuardPlaylistFavorite()
  }

  mounted () {
    const id = this.$route.params.id

    if (id) {
      this.favoriteId = (id as FavoriteId)
    }
  }

  get trackMap (): { [id: number]: RestTrack } {
    return Object.fromEntries(this.campaignTracks.map((t) => [t.id, t]))
  }

  get trackIdsSelected (): number[] {
    return this.$store.getters.campaignTrackIdsSelected
  }

  set trackIdsSelected (data: number[]) {
    this.$store.commit('SET_CAMPAIGN_TRACK_IDS_SELECTED', data)
  }

  get tracks (): RestTrack[] {
    return this.trackIdsSelected
      .map(selectedId => this.trackMap[selectedId])
      .filter((item) => !!item)
      .filter((_, index) => this.dataObj && !this.dataObj.indexListHide.includes(index))
  }

  // indexListHide is to hide tracks on some favorite screens.
  get dataObj (): { text: string, button: string, linkUrl: string, indexListHide: number[] } | null {
    switch (this.favoriteId) {
      case FavoriteId.OPENING: {
        return {
          text: this.$t('favoriteOpeningText'),
          button: this.$t('favoriteOpeningButton'),
          linkUrl: '/breaker/closing',
          indexListHide: [],
        }
      }
      case FavoriteId.CLOSING: {
        return {
          text: this.$t('favoriteClosingText'),
          button: this.$t('favoriteClosingButton'),
          linkUrl: '/breaker/encore',
          indexListHide: [0],
        }
      }
      case FavoriteId.ENCORE: {
        return {
          text: this.$t('favoriteEncoreText'),
          button: this.$t('favoriteEncoreButton'),
          linkUrl: '/playlist-sort',
          indexListHide: [0, this.trackIdsSelected.length - 1],
        }
      }
      default: {
        return null
      }
    }
  }

  onNext () {
    switch (this.favoriteId) {
      case FavoriteId.OPENING: {
        const index = this.trackIdsSelected.indexOf(this.selectedId)

        this.trackIdsSelected = move(this.trackIdsSelected, index, 0)
        break
      }
      case FavoriteId.CLOSING: {
        const index = this.trackIdsSelected.indexOf(this.selectedId)

        this.trackIdsSelected = move(this.trackIdsSelected, index, this.trackIdsSelected.length - 1)
        break
      }
      case FavoriteId.ENCORE: {
        const index = this.trackIdsSelected.indexOf(this.selectedId)

        this.trackIdsSelected = move(this.trackIdsSelected, index, this.trackIdsSelected.length)
        break
      }
      default: {
        break
      }
    }
  }
}
</script>
